import { grey } from "@mui/material/colors";

import { orderBy } from "lodash";

import { neutral } from "app/themes/colors";
import {
  TASK_PRIORITY_HIGH,
  TASK_PRIORITY_LOW,
  TASK_PRIORITY_MEDIUM,
  TASK_PRIORITY_NOT_SET,
  TASK_PRIORITY_URGENT,
  TASK_STATUS_CANCELLED,
  TASK_STATUS_COMPLETED
} from "constants/staff-tasks";
import type { StaffTasksGroupByPriorityResponse } from "services/types/staff-tasks.type";

export const cellSx = {
  pl: 1.5,
  fontWeight: 700,
  color: grey[700],
  background: neutral[100],
  whiteSpace: "normal",
  lineHeight: "normal",
  textTransform: "uppercase",
  letterSpacing: 0.7,
  fontSize: "14px",
  boxSizing: "border-box"
};

export const getCombinedTasksGroupedByPriority = (
  dataSet?: StaffTasksGroupByPriorityResponse[]
) => {
  const result: StaffTasksGroupByPriorityResponse = {
    totalCount: 0,
    items: {}
  };

  if (!dataSet?.length) {
    return result;
  }

  const taskIds = new Set<number>();

  dataSet.forEach((data, index) => {
    Object.entries(data.items).forEach(([priority, newItems]) => {
      if (!result.items[priority]) {
        result.items[priority] = {
          priority: Number(priority),
          count: 0,
          tasks: []
        };
      }

      const items = result.items[priority];
      const uniqTasks = newItems.tasks.filter((task) => !taskIds.has(task.id));

      items.count += uniqTasks.length;
      items.tasks.push(...uniqTasks);

      uniqTasks.forEach((task) => taskIds.add(task.id));
      result.totalCount += uniqTasks.length;
    });
  });

  Object.values(result.items).forEach((group) => {
    group.tasks = orderBy(
      group.tasks,
      [
        (task) =>
          task.status === TASK_STATUS_COMPLETED ||
          task.status === TASK_STATUS_CANCELLED
            ? 1
            : 0,
        (task) => (task.due_at ? 0 : 1),

        "due_at"
      ],
      ["asc", "asc", "desc"]
    );
  });

  return result;
};

export const getTasksByPriority = (
  data?: StaffTasksGroupByPriorityResponse
) => {
  const priorities = [
    TASK_PRIORITY_URGENT,
    TASK_PRIORITY_HIGH,
    TASK_PRIORITY_MEDIUM,
    TASK_PRIORITY_LOW,
    TASK_PRIORITY_NOT_SET
  ] as const;

  return priorities.map((priority) => ({
    data: data?.items[priority]?.tasks || [],
    priority,
    count: data?.items[priority]?.count || 0
  }));
};
